module.exports = __webpack_public_path__ + "img/change-password.baa9b685.png";